import { GET_VENDORS, GET_VENDOR_DETAILS } from "../actionTypes";

const defaultState = {
  vendors: [],
  selectedVendor: {}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_VENDORS:
      return { ...state, vendors: action.payload };
    case GET_VENDOR_DETAILS:
      return { ...state, selectedVendor: action.payload||defaultState.selectedVendor };
    default:
      return state;
  }
};
